import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {RefreshProvider} from './RefreshContext';
import Accounts from './components/Accounts';
import NavBar from './components/NavBar';
import Home from './components/Home';
import Transactions from './components/Transactions';
import AboutPayees from './components/onramp/AboutPayees';
import OnRamp from './components/onramp/OnRamp';
import NameYourFamilyOffice from './components/onramp/NameYourFamilyOffice';
import AboutMatchExpressions from './components/onramp/AboutMatchExpressions';
import AboutTransfers from './components/onramp/AboutTransfers';
import AboutTransactions from './components/onramp/AboutTransactions';
import LeftNav from './components/LeftNav';
import Account from './components/Account';
import DataView from './components/DataView';
import PassageAuth, {Login, Logout} from './components/PassageAuth';
import Search from './components/Search';
import TellerAuth from "./components/TellerAuth";
import EditFamilyOffice from "./components/EditFamilyOffice";

function App() {
  let step = 1;
  return (
    <PassageAuth>
      <Router>
        <TellerAuth>
          <RefreshProvider>
            <div className='container-fluid p-0 d-flex'>
              <LeftNav/>
              <div className="content row px-3">
                <Routes>
                  <Route exact path="/" element={<Home/>}/>
                  <Route path="/search" element={<Search/>}/>
                  <Route path="/login" element={<Login/>}/>
                  <Route path="/logout" element={<Logout/>}/>
                  <Route path="/views/:id" element={<DataView/>}/>
                  <Route path="/accounts" element={<Accounts/>}/>
                  <Route path="/accounts/:id" element={<Account/>}/>
                  <Route path="/settings" element={<EditFamilyOffice/>}/>

                  <Route path="/welcome" element={<OnRamp/>}>
                    <Route path=":step" element={<OnRamp/>}/>
                    <Route
                      path="get_started"
                      element={<NameYourFamilyOffice index={step}/>}
                    />
                    <Route
                      path="about_transactions"
                      element={<AboutTransactions index={step++}/>}
                    />
                    <Route
                      path="about_payees"
                      element={<AboutPayees index={step++}/>}
                    />
                    <Route
                      path="about_match_expressions"
                      element={<AboutMatchExpressions index={step++}/>}
                    />
                    <Route
                      path="about_transfers"
                      element={<AboutTransfers index={step++}/>}
                    />
                  </Route>
                </Routes>
              </div>
            </div>
          </RefreshProvider>
        </TellerAuth>
      </Router>
    </PassageAuth>
  );
}

export default App;
